import axios from 'axios';

import { assertClientSide } from '@dr.pogodin/react-utils';

import type {
  UpdateBlogItemBodyT,
  UpdateBlogItemResT,
} from 'server/controllers/blog';

import { type BlogItemT, P_API_BLOG, getConfig } from 'utils';

export async function updateBlogItem(
  id: string,
  update: Partial<BlogItemT>,
): Promise<BlogItemT> {
  assertClientSide();

  const { __v } = update;
  if (__v === undefined) throw Error('Internal error');

  const config = await getConfig();

  const res = await axios.patch<UpdateBlogItemResT>(
    `${P_API_BLOG}/${id}`,
    {
      _csrf: config.CSRF,
      ...update,
      __v,
    } satisfies UpdateBlogItemBodyT,
  );

  return res.data;
}
